module.exports = __webpack_public_path__ + "img/manda_026.288adec5.png";